import React, { memo, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import type { RouteComponentProps } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { App } from 'antd';

import QueryString from 'query-string';
import type { IStatusFilter } from 'v2/interfaces/affiliate';
import affiliateService from 'v2/services/affiliate';

import TableApproved from './TableApproved';
import TablePending from './TablePending';
import TableReproved from './TableReproved';

type IProps = RouteComponentProps<Record<string, string>>;

const Table = ({ location }: IProps) => {
  const { message } = App.useApp();
  const [isLoading] = useObservable(() => affiliateService.isLoading(), []);
  const [filters] = useObservable(() => affiliateService.getFilters(), []);

  useEffect(() => {
    const params = QueryString.parse(location.search);

    if (params?.p && params?.status) {
      affiliateService.setFilter({
        status: params.status as IStatusFilter,
        product_id: [Number(params.p)]
      });
    }

    affiliateService.loadAffiliates().subscribe(
      () => {},
      () => message.error('Não foi possível carregar os afiliados.')
    );
  }, [location, message]);

  const onSort = (sortField: string, sortDirection: 'asc' | 'desc') => {
    affiliateService.setOrdering(sortDirection);
    affiliateService.setFilter({ order: `${sortField}-${sortDirection}` });
    affiliateService.setCurrentSort({
      direction: sortDirection,
      field: sortField
    });
  };

  if (isLoading === null) {
    return null;
  }

  return (
    <div className='relative w-full'>
      {filters?.status === 'pending' && <TablePending onSort={onSort} />}
      {filters?.status === 'approved' && <TableApproved onSort={onSort} />}
      {filters?.status === 'reproved' && <TableReproved onSort={onSort} />}
    </div>
  );
};

export default withRouter(memo(Table));
